import React from "react";
import { capture } from "../../../analytics";

// Top-of-dashboard call to action for women: the GroupMe chat is where
// the group actually lives, so for them it outranks every other card.
// Shown every visit, joined or not (there's no reliable "already in
// GroupMe" signal, and a one-tap way back to the chat is useful
// anyway). Tapping opens the Chats tab, whose join panel tells them
// which phone number to use so the join request matches their account.
const JoinChatBanner = ({ onOpen }) => (
  <button
    type="button"
    onClick={() => {
      capture("join_chat_banner_clicked");
      if (onOpen) onOpen();
    }}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 14,
      width: "100%",
      marginBottom: 14,
      padding: "16px 18px",
      background: "linear-gradient(135deg, #ff5f8f 0%, #ff8a5c 100%)",
      color: "#fff",
      border: "none",
      borderRadius: 14,
      boxShadow: "0 6px 18px rgba(255, 95, 143, 0.35)",
      textAlign: "left",
      cursor: "pointer",
    }}
  >
    <span style={{ fontSize: 34, lineHeight: 1 }} aria-hidden="true">
      💬
    </span>
    <span style={{ flex: 1 }}>
      <span
        style={{
          display: "block",
          fontSize: 22,
          fontWeight: 800,
          letterSpacing: "0.01em",
          lineHeight: 1.15,
        }}
      >
        Join our Group Chat!
      </span>
      <span style={{ display: "block", fontSize: 14, marginTop: 4, opacity: 0.95 }}>
        Event invites, who's going, carpools and last-minute plans all
        happen in our GroupMe.
      </span>
    </span>
    <span
      style={{
        fontSize: 15,
        fontWeight: 800,
        background: "#fff",
        color: "#e84a78",
        borderRadius: 999,
        padding: "8px 14px",
        whiteSpace: "nowrap",
      }}
    >
      Join →
    </span>
  </button>
);

export default JoinChatBanner;
